import {ItemRarity} from '../../generated/types';

export const ItemRarityNames: Record<
	ItemRarity,
	{
		male: string;
		female: string;
		other: string;
		multiple: string;
		price?: number;
		legacyPriceMin?: number;
		legacyPriceMax?: number;
		legacyPriceDice?: string;
	}
> = {
	Uncommon: {
		male: 'Необычный',
		female: 'Необычная',
		other: 'Необычное',
		multiple: 'Необычные',
		price: 400,
		legacyPriceMin: 101,
		legacyPriceMax: 500,
		legacyPriceDice: '1d6 × 100',
	},
	Rare: {
		male: 'Редкий',
		female: 'Редкая',
		other: 'Редкое',
		multiple: 'Редкие',
		price: 4000,
		legacyPriceMin: 501,
		legacyPriceMax: 5_000,
		legacyPriceDice: '2d10 × 1 000',
	},
	VeryRare: {
		male: 'Крайне редкий',
		female: 'Крайне редкая',
		other: 'Крайне редкое',
		multiple: 'Крайне редкие',
		price: 40_000,
		legacyPriceMin: 5_001,
		legacyPriceMax: 50_000,
		legacyPriceDice: '(1d4 + 1) × 10 000',
	},
	Unknown: {
		male: 'неизвестной редкости',
		female: 'неизвестной редкости',
		other: 'неизвестной редкости',
		multiple: 'неизвестной редкости',
	},
	Legendary: {
		male: 'Легендарный',
		female: 'Легендарная',
		other: 'Легендарное',
		multiple: 'Легендарные',
		price: 200_000,
		legacyPriceMin: 50_001,
		legacyPriceDice: '2d6 × 25 000',
	},
	Artifact: {male: 'Артефакт', female: 'Артефакт', other: 'Артефакт', multiple: 'Артефакты'},
	Common: {
		male: 'Обычный',
		female: 'Обычная',
		other: 'Обычное',
		multiple: 'Обычные',
		price: 100,
		legacyPriceMin: 50,
		legacyPriceMax: 100,
		legacyPriceDice: '(1d6 + 1) × 10',
	},
	UnknownMagic: {
		male: 'неизвестной редкости (магический)',
		female: 'неизвестной редкости (магическая)',
		other: 'неизвестной редкости (магическое)',
		multiple: 'неизвестной редкости (магические)',
	},
	Varies: {
		male: 'различной редкости',
		female: 'различной редкости',
		other: 'различная редкость',
		multiple: 'различной редкости',
	},
	None: {
		male: '',
		female: '',
		multiple: '',
		other: '',
	},
};
